import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { AssignmentToDutyActions, AssignmentToDutyActionTypes } from './assignment-to-duty.actions';
import { AssignmentToDutyEntity } from './assignment-to-duty.model';

export interface AssignmentToDutyEntities extends EntityState<AssignmentToDutyEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<AssignmentToDutyEntity> = createEntityAdapter<
  AssignmentToDutyEntity
>();

export const initialState: AssignmentToDutyEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): AssignmentToDutyEntities {
  const action = incomingAction as AssignmentToDutyActions;
  switch (action.type) {
    case AssignmentToDutyActionTypes.AddAssignmentToDuty: {
      return adapter.addOne(action.payload.assignmentToDuty, state);
    }

    case AssignmentToDutyActionTypes.UpsertAssignmentToDuty: {
      return adapter.upsertOne(action.payload.assignmentToDuty, state);
    }

    case AssignmentToDutyActionTypes.AddAssignmentToDuties: {
      return adapter.addMany(action.payload.assignmentToDuties, state);
    }

    case AssignmentToDutyActionTypes.UpsertAssignmentToDuties: {
      return adapter.upsertMany(action.payload.assignmentToDuties, state);
    }

    case AssignmentToDutyActionTypes.UpdateAssignmentToDuty: {
      return adapter.updateOne(action.payload.assignmentToDuty, state);
    }

    case AssignmentToDutyActionTypes.UpdateAssignmentToDuties: {
      return adapter.updateMany(action.payload.assignmentToDuties, state);
    }

    case AssignmentToDutyActionTypes.DeleteAssignmentToDuty: {
      return adapter.removeOne(action.payload.id, state);
    }

    case AssignmentToDutyActionTypes.DeleteAssignmentToDuties: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case AssignmentToDutyActionTypes.LoadAssignmentToDuties: {
      return adapter.setAll(action.payload.assignmentToDuties, state);
    }

    case AssignmentToDutyActionTypes.ClearAssignmentToDuties: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
